module.exports = __webpack_public_path__ + "media/svg/deployer-bfccd2f5.svg";